export default "__VITE_ASSET__DamgMRC___"